import { MapTo } from '@adobe/aem-react-editable-components';
import VideoPlaylist, { VideoPlaylistEditConfig } from './VideoPlaylist';

export default MapTo('cob-corp-acquisition/components/creditonebank/video-playlist')(VideoPlaylist, VideoPlaylistEditConfig);